export default "__VITE_ASSET__FbL5dSq8__"